/**
 * Счётчики собранных объектов (/v2/collected_group/counters): число хранилищ для
 * меню рабочего места. Пока ответа нет или запрос не удался, число неизвестно —
 * null, а не 0.
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface CollectedCounters {
	endpoints: number;
	internal_assets: number;
	external_assets: number;
	buckets: number;
	kafka_instances: number;
	kafka_topics: number;
	sql_db_instances: number;
	sql_db_databases: number;
	sql_db_tables: number;
	no_sql_db_databases: number;
}

/** Хранилища: бакеты, инстансы Kafka и базы SQL и NoSQL */
export function storageCount(counters: CollectedCounters | undefined): number | null {
	if (!counters) return null;
	return (
		counters.buckets +
		counters.kafka_instances +
		counters.sql_db_databases +
		counters.no_sql_db_databases
	);
}

export function useCollectedCounters() {
	return useQuery({
		queryKey: ['collected-group-counters'],
		queryFn: () => api.get<CollectedCounters>('/v2/collected_group/counters'),
		staleTime: 60_000,
	});
}
